"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChangePasswordMutation = exports.useDisableUserMutation = exports.useEnableUserMutation = exports.useUnlockUserMutation = exports.useResetPasswordMutation = exports.useDeleteUserMutation = exports.useUpdateUserMutation = exports.useCreateUserMutation = exports.useGetUserQuery = exports.useLazyGetUsersQuery = exports.useGetUsersQuery = exports.usersApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.usersApi = (0, react_1.createApi)({
    reducerPath: "usersApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["Users"],
    endpoints: function (builder) { return ({
        getUsers: builder.query({
            query: function (params) { return ({
                url: "/v1/users",
                params: params,
            }); },
            providesTags: function (result) {
                var _a;
                var users = ((_a = result === null || result === void 0 ? void 0 : result.content) === null || _a === void 0 ? void 0 : _a.users) || [];
                return users.length > 0
                    ? __spreadArray(__spreadArray([], users.map(function (_a) {
                        var _id = _a._id;
                        return ({
                            type: "Users",
                            id: _id,
                        });
                    }), true), [
                        { type: "Users", id: "LIST" },
                    ], false) : [{ type: "Users", id: "LIST" }];
            },
        }),
        getUser: builder.query({
            query: function (id) { return "/v1/users/".concat(id); },
            providesTags: function (result, error, id) { return [{ type: "Users", id: id }]; },
        }),
        createUser: builder.mutation({
            query: function (data) { return ({
                url: "/v1/users",
                method: "POST",
                body: data,
            }); },
            invalidatesTags: [{ type: "Users", id: "LIST" }],
        }),
        updateUser: builder.mutation({
            query: function (_a) {
                var id = _a.id, data = _a.data;
                return ({
                    url: "/v1/users/".concat(id),
                    method: "PATCH",
                    body: data,
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "Users", id: id },
                    { type: "Users", id: "LIST" },
                ];
            },
        }),
        deleteUser: builder.mutation({
            query: function (id) { return ({
                url: "/v1/users/".concat(id),
                method: "DELETE",
            }); },
            invalidatesTags: [{ type: "Users", id: "LIST" }],
        }),
        resetPassword: builder.mutation({
            query: function (id) { return ({
                url: "/v1/users/".concat(id, "/reset-password"),
                method: "POST",
            }); },
        }),
        unlockUser: builder.mutation({
            query: function (id) { return ({
                url: "/v1/users/".concat(id, "/unlock"),
                method: "POST",
            }); },
            invalidatesTags: function (result, error, id) { return [
                { type: "Users", id: id },
                { type: "Users", id: "LIST" },
            ]; },
        }),
        enableUser: builder.mutation({
            query: function (id) { return ({
                url: "/v1/users/".concat(id, "/enable"),
                method: "POST",
            }); },
            invalidatesTags: function (result, error, id) { return [
                { type: "Users", id: id },
                { type: "Users", id: "LIST" },
            ]; },
        }),
        disableUser: builder.mutation({
            query: function (id) { return ({
                url: "/v1/users/".concat(id, "/disable"),
                method: "POST",
            }); },
            invalidatesTags: function (result, error, id) { return [
                { type: "Users", id: id },
                { type: "Users", id: "LIST" },
            ]; },
        }),
        changePassword: builder.mutation({
            query: function (data) { return ({
                url: "/v1/users/change-password",
                method: "POST",
                body: data,
            }); },
        }),
    }); },
});
exports.useGetUsersQuery = exports.usersApi.useGetUsersQuery, exports.useLazyGetUsersQuery = exports.usersApi.useLazyGetUsersQuery, exports.useGetUserQuery = exports.usersApi.useGetUserQuery, exports.useCreateUserMutation = exports.usersApi.useCreateUserMutation, exports.useUpdateUserMutation = exports.usersApi.useUpdateUserMutation, exports.useDeleteUserMutation = exports.usersApi.useDeleteUserMutation, exports.useResetPasswordMutation = exports.usersApi.useResetPasswordMutation, exports.useUnlockUserMutation = exports.usersApi.useUnlockUserMutation, exports.useEnableUserMutation = exports.usersApi.useEnableUserMutation, exports.useDisableUserMutation = exports.usersApi.useDisableUserMutation, exports.useChangePasswordMutation = exports.usersApi.useChangePasswordMutation;
